// API configuration
declare global {
  interface Window {
    PERCY_CONFIG: {
      API_URL: string;
    };
  }
}

export const API_URL = window.PERCY_CONFIG?.API_URL || 'http://localhost:8000';